import { combineReducers } from 'redux';
import { uiAlertsReducer } from './alerts';

export default combineReducers({ alerts: uiAlertsReducer });
